import gql from 'graphql-tag';

import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendBrandVoice, BackendQueryBrandVoiceArgs } from 'src/types/backend';

import { FRAGMENT_BRAND_VOICE } from './schema';

const QUERY = gql`
  query BrandVoice($id: ID!) {
    brandVoice(id: $id) {
      ...BrandVoice
    }
  }
  ${FRAGMENT_BRAND_VOICE}
`;

type Variables = BackendQueryBrandVoiceArgs;
type Result = Pick<BackendBrandVoice, 'id' | 'name' | 'language'>;

export const queryBrandVoice = async (variables: Variables) => {
  const result = await executeGqlQuery({
    query: QUERY,
    variables,
  });

  return getSingleProp<Result>(result.data);
};
